import CashbackIcon from '../CashbackIcon';
import type { Language } from '../../i18n';
import { useTranslation } from '../../hooks/useTranslation';

interface RewardsHubCardProps {
  points: number;
  language: Language;
  onRedeemClick: () => void;
  formatPoints: (points: number) => string;
}

const RewardsHubCard = ({ points, onRedeemClick, formatPoints }: RewardsHubCardProps) => {
  const { t } = useTranslation();
  
  return (
    <div className="relative overflow-hidden rounded-2xl mb-6">
      {/* Animated Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/20 via-yellow-500/10 to-primary/20" />
      <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/5 to-transparent animate-pulse" />
      
      <div className="relative bg-gradient-to-br from-gray-800/80 to-gray-900/80 backdrop-blur-xl p-6 border rounded-2xl border-primary/30">
        <div className="flex items-center justify-between mb-4">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-1">
              <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-primary to-yellow-500 flex items-center justify-center">
                <svg className="w-5 h-5 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
                </svg>
              </div>
              <h1 className="text-xl font-bold text-white">Rewards Hub</h1>
            </div>
            <p className="text-xs text-gray-400">
              {t('checkIn.subtitle')}
            </p>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-2xl bg-primary/20 border border-primary/30 flex items-center justify-center">
              <CashbackIcon size={32} />
            </div>
            <div>
              <div className="text-3xl font-black bg-gradient-to-r from-primary via-yellow-400 to-primary bg-clip-text text-transparent">
                {formatPoints(points)}
              </div>
              <div className="text-xs text-gray-400 font-medium">
                {t('dashboard.availablePoints')}
              </div>
            </div>
          </div>

          <button
            onClick={onRedeemClick}
            className="px-6 py-3 bg-gradient-to-r from-primary via-yellow-400 to-primary text-black rounded-xl font-bold hover:scale-105 hover:shadow-2xl hover:shadow-primary/50 transition-all duration-300 active:scale-95 flex items-center gap-2"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
            </svg>
            <span className="hidden sm:inline">
              {t('checkIn.redeem')}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default RewardsHubCard;

